class FileUtils {
    public static getFileNameFromPath(path: string) {
        let name=path;
        let slashIndex=name.indexOf('/');
        if(slashIndex>=0) {
            name=name.substring(slashIndex+1);
        }
        let antiSlashIndex=name.indexOf('\\');
        if(antiSlashIndex>=0) {
            name=name.substring(antiSlashIndex+1);
        }

        return name;
    }

    public static getFileExtensionName(path: string) {
        let name = this.getFileNameFromPath(path);
        let lastDotIndex = name.lastIndexOf('.');
        if (lastDotIndex < 0) {
            return '';
        }
        let extensionName = name.substring(lastDotIndex + 1);
        return extensionName;
    }
}

export default FileUtils;
